export default __webpack_public_path__ + "static/media/Henkel.0ed75dd9.png";